import React, { useEffect, useState } from "react";
import Common_Product_Swiper from "../common_components/common_product_swiper/Common_Product_Swiper";
import Shop_Banner from "./shop_banner/Shop_Banner";
import Banner_Btn_Component from "../home/banner_btn_component/Banner_Btn_Component";
import {
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const ShopSingle = () => {
  const data1 = [
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
  ];

  const data2 = [
    {
      img: "/assets/images/products/img3.png",
      label: "Chips",
    },
    {
      img: "/assets/images/products/img4.png",
      label: "Cold Drinks and Juices",
    },
    {
      img: "/assets/images/products/img5.png",
      label: "Ice Cream and Frozen Desserts",
    },
    {
      img: "/assets/images/products/img3.png",
      label: "Chips",
    },
    {
      img: "/assets/images/products/img4.png",
      label: "Cold Drinks and Juices",
    },
    {
      img: "/assets/images/products/img5.png",
      label: "Ice Cream and Frozen Desserts",
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const categoryWiseProduct = useSelector(
    (state) => state.product.allProductsGroup
  );

  // Parse the query string
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("category_id");
  const { id } = useParams();
  useEffect(() => {
    dispatch(getGroupByProduct({ p_category_id: id }));
    // if (location.hash) {
    //   const id = location.hash.replace("#", "");
    //   const el = document.getElementById(id);
    //   if (el) {
    //     el.scrollIntoView({ behavior: "smooth" });
    //   }
    // }
  }, [location, dispatch, searchValue]);

  return (
    <section className="Shop">
      <div className="container">
        {categoryWiseProduct?.data?.map((val, index) => (
          <div className="grocery_div" key={index}>
            <Common_Product_Swiper
              //   data={category}
              //   theme_colour={"brown"}
              //   headingText={category.name}

              data={val}
              background_color={val?.background_color}
              button_color={val?.button_color}
              headingText={val?.name}
            />
          </div>
        ))}

        <div>
          <Shop_Banner></Shop_Banner>
        </div>

        <div>
          <Banner_Btn_Component></Banner_Btn_Component>
        </div>
      </div>
    </section>
  );
};

export default ShopSingle;
